const getValues = function(str) {
  return str
    .replace(/[A-Z]/gi, "")
    .split(", ")
    .map(parseFloat);
};

const getMaxTransitionProp = function(el) {
  const style = window.getComputedStyle(el);
  const props = style.transitionProperty.split(", ");
  const delays = getValues(style.transitionDelay);
  const durations = getValues(style.transitionDuration);
  const totals = durations.map(function(v, i) {
    return v + delays[i];
  });

  const maxIndex = 
    totals.reduce((res, cur, i) => {
      if (res.val > cur) {
        res.val = cur;
        res.i = i;
      }
      return res;
    }, {val: -Infinity, i: 0});

  return props[maxIndex.i];
}

function lastTransitionEnd(dom, prop, cb) {
  const lastProp = prop ?? getMaxTransitionProp(dom);
  return function(e) {
    if (e.target === dom && e.originalEvent.propertyName == lastProp) {
      cb(e);
    }
  };
};

;(($) => {

  $.lastTransitionEnd = function({dom, prop}, cb) {
    const lastProp = prop ?? getMaxTransitionProp(dom[0]);
    return function(e) {
      if (e.target === dom[0] && e.originalEvent.propertyName == lastProp) {
        cb(e);
      }
    };
  }
  
  $.fn.propTransitionEnd = function(prop, cb) {
    $(this).on('transitionend', lastTransitionEnd(this[0], prop, cb));
  }
  
})( jQuery );

